@if (categoryAnalysisResponse) {
<div class="category-analysis-container">
  <!-- Row 1: Average Category Performance + Category performance chart (new flow) -->
  @if (averageCategoryPerformance) {
  <div class="top-row category-insights-row">
    <div class="average-performance-card">
      <app-composite-score-widget
        [compositeScore]="averageCategoryPerformanceScore ?? averageCategoryPerformance.average_score"
        [title]="'Average Category Performance'"
        [size]="'medium'">
      </app-composite-score-widget>
      <p class="average-performance-subtitle">Average Category Performance (you vs average of all brands)</p>
      <p class="average-performance-text">
        You are <strong>{{ averageCategoryPerformance.comparison_pct > 0 ? '+' : '' }}{{ averageCategoryPerformance.comparison_pct }}%</strong>
        {{ averageCategoryPerformance.comparison_pct <= 0 ? 'down' : 'up' }} the average score compared to {{ averageCategoryPerformance.competitor_count }} competitor{{ averageCategoryPerformance.competitor_count !== 1 ? 's' : '' }}.
      </p>
    </div>
    <div class="chart-section">
      <div class="chart-header">
        <h4 class="chart-title">Category performance</h4>
      </div>
      <div class="chart-mobile-wrapper">
        @if (categoryPerformanceList.length > 0) {
        <div class="combo-chart-wrapper">
          <app-bar-line-combo-chart [view]="view" [scheme]="comboBarScheme" [results]="categoryPerformanceList"
            [animations]="true" [tooltipDisabled]="false" [gradient]="false" [xAxis]="true" [yAxis]="true"
            [legend]="false" [showGridLines]="true" [showXAxisLabel]="true" [showYAxisLabel]="true"
            [xAxisLabel]="'Categories'" [yAxisLabel]="'Score'" [wrapTicks]="true"
            (select)="onSelect($event)" (activate)="onActivate($event)" (deactivate)="onDeactivate($event)">
          </app-bar-line-combo-chart>
        </div>
        }
      </div>
    </div>
  </div>
  @if (aiTableSummaryText) {
  <div class="category-summary-below-chart">
    <div class="category-performance-summary-block">
      <p class="summary-title">Summary</p>
      <p class="category-performance-summary">{{ aiTableSummaryText }}</p>
    </div>
  </div>
  }
  }

  <!-- Row 2: Category vs current brand + Brand + competitors by category (reuse combo chart) -->
  @if (!averageCategoryPerformance && (results.length > 0 || lineChart.length > 0)) {
  <div class="top-row score-chart-column">
    <app-composite-score-widget [compositeScore]="compositeScore" [title]="'Category Analysis Score'" [size]="'medium'">
    </app-composite-score-widget>
    <div class="chart-section">
      <div class="chart-header">
        <h4 class="chart-title">AI Category Insights</h4>
        <p class="chart-subtitle">{{ getChartSubtitle() }}</p>
      </div>
      <div class="chart-mobile-wrapper" #chartContainer>
        @if(shouldRenderChart) {
        <div class="combo-chart-wrapper">
          <app-bar-line-combo-chart [view]="view" [scheme]="comboBarScheme" [colorSchemeLine]="lineChartScheme"
            [results]="results" [lineChart]="lineChart" [barBrandName]="firstBrandName || 'Your Brand'"
            [animations]="true" [tooltipDisabled]="false" [yAxisTickFormatting]="yLeftTickFormat"
            [yLeftAxisScaleFactor]="yLeftAxisScale" [yRightAxisScaleFactor]="yRightAxisScale"
            [yRightAxisTickFormatting]="yRightTickFormat" [gradient]="false" [xAxis]="true" [yAxis]="true"
            [legend]="true" [legendTitle]="''" [legendPosition]="'right'" [showGridLines]="true"
            [showXAxisLabel]="true" [showYAxisLabel]="true" [showRightYAxisLabel]="true"
            [xAxisLabel]="'Business Areas'" [yAxisLabel]="'Score'" [yAxisLabelRight]="'Score'"
            [noBarWhenZero]="true" [wrapTicks]="true" (select)="onSelect($event)" (activate)="onActivate($event)"
            (deactivate)="onDeactivate($event)">
          </app-bar-line-combo-chart>
        </div>
        } @else {
        <div class="chart-placeholder"><p>Chart will load when tab becomes visible...</p></div>
        }
      </div>
    </div>
  </div>
  }

  @if (averageCategoryPerformance && shouldRenderChart && (results.length > 0 || lineChart.length > 0)) {
  <div class="second-row charts-row">
    <div class="chart-section half">
      <div class="chart-header">
        <h4 class="chart-title">Category vs current brand</h4>
      </div>
      <div class="chart-mobile-wrapper">
        <app-bar-line-combo-chart [view]="view" [scheme]="comboBarScheme" [results]="categoryVsBrandChartResults"
          [lineChart]="categoryVsBrandChartLineSeries ? [categoryVsBrandChartLineSeries] : []"
          [barBrandName]="firstBrandName" [animations]="true" [tooltipDisabled]="false" [gradient]="false"
          [xAxis]="true" [yAxis]="true" [legend]="true" [legendTitle]="''" [showGridLines]="true"
          (select)="onSelect($event)" (activate)="onActivate($event)" (deactivate)="onDeactivate($event)">
        </app-bar-line-combo-chart>
      </div>
    </div>
    <div class="chart-section half">
      <div class="chart-header">
        <h4 class="chart-title">Brand + competitors by category</h4>
      </div>
      <div class="chart-mobile-wrapper" #chartContainer>
        <app-bar-line-combo-chart [view]="view" [scheme]="comboBarScheme" [colorSchemeLine]="lineChartScheme"
          [results]="results" [lineChart]="lineChart" [barBrandName]="firstBrandName"
          [animations]="true" [tooltipDisabled]="false" [gradient]="false" [xAxis]="true" [yAxis]="true"
          [legend]="true" [legendTitle]="''" [showGridLines]="true"
          (select)="onSelect($event)" (activate)="onActivate($event)" (deactivate)="onDeactivate($event)">
        </app-bar-line-combo-chart>
      </div>
    </div>
  </div>
  }

  <!-- AI Visibility Table (legacy / when no new flow) -->
  @if (tableRows.length > 0 && !averageCategoryPerformance) {
  <app-common-performance-table [rows]="tableRows" [columns]="tableColumns" [title]="'AI Visibility Table by Category'">
  </app-common-performance-table>
  }

  @if (categoryDemandData.length > 0 && !averageCategoryPerformance) {
  <div class="chart-section">
    <div class="chart-header">
      <h4 class="chart-title">Category Performance (High-Demand Areas)</h4>
    </div>
    <div class="chart-mobile-wrapper">
      <app-bar-line-combo-chart [view]="view" [scheme]="comboBarScheme" [results]="categoryDemandData"
        [animations]="true" [tooltipDisabled]="false" [gradient]="false" [xAxis]="true" [yAxis]="true"
        [legend]="false" [showGridLines]="true" [xAxisLabel]="'Categories'" [yAxisLabel]="'Rating'" [wrapTicks]="true"
        (select)="onSelect($event)" (activate)="onActivate($event)" (deactivate)="onDeactivate($event)">
      </app-bar-line-combo-chart>
    </div>
  </div>
  }

  @if (subjectDemandData.length > 0 && !averageCategoryPerformance) {
  <div class="chart-section">
    <div class="chart-header">
      <h4 class="chart-title">Subject Demand Analysis</h4>
    </div>
    <div class="chart-mobile-wrapper">
      <app-bar-line-combo-chart [view]="view" [scheme]="comboBarScheme" [results]="subjectDemandData"
        [animations]="true" [tooltipDisabled]="false" [gradient]="false" [xAxis]="true" [yAxis]="true"
        [legend]="false" [xAxisLabel]="'Metrics'" [yAxisLabel]="'Value'" [wrapTicks]="true"
        (select)="onSelect($event)" (activate)="onActivate($event)" (deactivate)="onDeactivate($event)">
      </app-bar-line-combo-chart>
    </div>
  </div>
  }

  <!-- Row 3: Most cited domains list and chart -->
  @if (mostCitedDomainsList.length > 0) {
  <div class="most-cited-section">
    <h4 class="section-title">Category insights</h4>
    <h5 class="subsection-title">Most cited domains in this category</h5>
    <div class="most-cited-row">
      <div class="most-cited-table">
        <table>
          <thead>
            <tr><th>Domain</th><th>Score</th></tr>
          </thead>
          <tbody>
            @for (d of mostCitedDomainsList; track d.name) {
            <tr><td>{{ d.name }}</td><td>{{ d.score }}</td></tr>
            }
          </tbody>
        </table>
      </div>
      <div class="most-cited-chart">
        <app-bar-line-combo-chart [view]="view" [scheme]="comboBarScheme"
          [results]="mostCitedDomainsChartResults"
          [animations]="true" [tooltipDisabled]="false" [gradient]="false" [xAxis]="true" [yAxis]="true"
          [legend]="false" [showGridLines]="true" [xAxisLabel]="''" [yAxisLabel]="'Score'" [wrapTicks]="true"
          (select)="onSelect($event)" (activate)="onActivate($event)" (deactivate)="onDeactivate($event)">
        </app-bar-line-combo-chart>
      </div>
    </div>
  </div>
  }

  <!-- Row 5: Strengths and Areas for Improvement -->
  @if (getStrengths().length > 0 || getWeaknesses().length > 0) {
  <div class="strengths-section">
    <mat-card>
      <mat-card-header>
        <mat-card-title>Strengths and Areas for Improvement</mat-card-title>
        <mat-card-subtitle>Comprehensive analysis of {{ firstBrandName }} performance</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <div class="analysis-grid">
          <div class="strengths-column">
            <h5>Strengths:</h5>
            <ul>
              @for (strength of getStrengths(); track strength) {
              <li>{{ strength }}</li>
              }
            </ul>
          </div>
          <div class="weaknesses-column">
            <h5>Areas for Improvement:</h5>
            <ul>
              @for (weakness of getWeaknesses(); track weakness) {
              <li>{{ weakness }}</li>
              }
            </ul>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  }

  <!-- Row 6: Category Trends -->
  @if (categoryTrendsList.length > 0) {
  <div class="category-trends-section">
    <h4 class="section-title">Category Trends</h4>
    <ul class="trends-list">
      @for (t of categoryTrendsList; track t.summary) {
      <li>
        {{ t.summary }}
        @if (t.source) { <span class="trend-source">({{ t.source }})</span> }
      </li>
      }
    </ul>
  </div>
  }
</div>
} @else if (categoryAnalysisBgLoad.phase !== 'idle' || isLlmVisibilityLoading) {
<div class="category-analysis-loading-panel">
  <mat-spinner diameter="48"></mat-spinner>
  <h3>Building category view from AI Visibility &amp; competitor prompts…</h3>
  <p class="load-hint">
    When Overview finishes, this tab rebuilds from that data—no separate category batch.
  </p>
  @if (llmVisibilityProgress?.current_step) {
  <p class="load-step">{{ llmVisibilityProgress?.current_step }}</p>
  }
  @if (categoryAnalysisBgLoad.taskId) {
  <p class="task-id-row"><span class="label">Job</span> <code>{{ categoryAnalysisBgLoad.taskId }}</code></p>
  }
  @if (llmVisibilityTaskId) {
  <p class="task-id-row"><span class="label">AI Visibility task</span> <code>{{ llmVisibilityTaskId }}</code></p>
  }
</div>
} @else {
<div class="category-analysis-empty-panel">
  <p>Category analysis is built from your brand’s AI Visibility data and competitor discovery prompts. Open Overview and wait for analysis to complete, then return here—or refresh this version.</p>
  <button mat-stroked-button color="primary" type="button" (click)="reloadCategoryAnalysis()">Rebuild from AI Visibility</button>
</div>
}
